import React, { useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useGetRequestUrl } from '../hooks/useGetRequestUrl';

export default function Register() {
  const requestUrl = useGetRequestUrl();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = () => {
    axios
      .post(
        `${requestUrl}/auth/signup`,
        {
          email: email,
          password: password,
        },
        { withCredentials: false }
      )
      .then(function (response) {
        console.log(response.data);
        navigate('/login');
      });
  };

  return (
    <Stack justifyContent="center" alignItems="center" spacing={2} mt="100px">
      <Typography fontWeight="700" fontSize="30px">
        Register
      </Typography>
      <TextField
        variant="outlined"
        placeholder="Email"
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
        }}
      />
      <TextField
        variant="outlined"
        placeholder="Password"
        type="password"
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
        }}
      />
      <Button onClick={handleSubmit} color="success" variant="contained">
        Register
      </Button>
    </Stack>
  );
}
